var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBscBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 86,
    viewBox: "0 0 82 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5 101C78.3904 101 101 78.3904 101 50.5C101 22.6096 78.3904 0 50.5 0C22.6096 0 0 22.6096 0 50.5C0 78.3904 22.6096 101 50.5 101Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9364 46.1601L50.5 35.5965L61.0636 46.17L67.2084 40.0251L50.5 23.3069L33.7916 40.0153L39.9364 46.1601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3083 50.4951L29.4527 44.3506L35.5972 50.4949L29.4529 56.6395L23.3083 50.4951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9364 54.8398L50.5 65.4034L61.0636 54.83L67.2183 60.9748H67.2084L50.5 77.693L33.7916 60.9846L33.7817 60.9748L39.9364 54.8398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4005 50.5055L71.5448 44.3609L77.6894 50.5053L71.5451 56.6498L65.4005 50.5055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7336 50.5L50.5 44.2566L45.8939 48.8726L45.3613 49.3954L44.2665 50.4902L44.2566 50.5L44.2665 50.5099L50.5 56.7435L56.7336 50.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscBg);
export default __webpack_public_path__ + "static/media/bsc_bg.9da27ed4b6e7bf2ec1c78c3d0fcfef82.svg";
export { ForwardRef as ReactComponent };